import { ReactNode, useCallback, useContext, useEffect } from 'react';

import { useAuth } from '../../../hooks/useAuth/useAuth';
import { UserContext } from 'context/UserContext';
import { useLogoutFlow } from 'hooks/useLogout/useLogoutFlow';
import { FullScreenLoader } from '../FullscreenLoader/FullscreenLoader';
import { ExtendSessionDailog } from '../ExtendSessionDailog';
import { AutoExtendSession } from '../AutoExtendSession';

export const SessionProtectedRoute = ({ children }: { children: ReactNode }) => {
    const { extendUserSession, getSession } = useAuth();
    const { showExtendSessionDailog, setShowExtendSessionDailog } = useContext(UserContext);
    const { logout, loading } = useLogoutFlow();

    useEffect(() => {
        getSession();
    }, []);

    const handleLogout = useCallback(
        (isAutoLogout?: boolean) => {
            setShowExtendSessionDailog(false);
            logout(isAutoLogout);
        },
        [setShowExtendSessionDailog, logout]
    );

    const handleExtend = useCallback(() => {
        setShowExtendSessionDailog(false);
        extendUserSession();
    }, [setShowExtendSessionDailog, extendUserSession]);

    return (
        <>
            <FullScreenLoader loading={loading} />
            {showExtendSessionDailog ? (
                <ExtendSessionDailog handleExtend={handleExtend} handleLogout={handleLogout} />
            ) : (
                <AutoExtendSession />
            )}
            {children}
        </>
    );
};
